import { render, staticRenderFns } from "./Meteo.vue?vue&type=template&id=0c84dc68&scoped=true&"
import script from "./Meteo.vue?vue&type=script&lang=js&"
export * from "./Meteo.vue?vue&type=script&lang=js&"
import style0 from "./Meteo.vue?vue&type=style&index=0&id=0c84dc68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c84dc68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VImg,VLayout})
